import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductDetailsDescription } from '../_models/ProductDetailsDescription';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
})
export class ProductDetailsDescriptionService {
  requestParam : String;

  constructor(private http: HttpClient) { }
  public static readonly GET_PRODUCT_DETAILS_BY_ID = environment.apiURL + 'getProductDetailsByProductId/';
  public static readonly GET_ALL_PRODUCTS_CONTROLLER = environment.apiURL + 'getAllProducts';

/*Method for fetching all category details-----*/
public getProductDetailsByProductId(id,userId): Observable<ProductDetailsDescription> {
  let params = "?productId=" + id+"&userId="+userId;
  return this.http.get<ProductDetailsDescription>(ProductDetailsDescriptionService.GET_PRODUCT_DETAILS_BY_ID + params)
    .pipe(map(response => {
      return response;
    }));
}
// getAllProducts(productId : string, clientId : string , userId: number){
//   productId == null ? null : productId;
//   this.requestParam="?productId="+ productId +"&clientId=1" + "&userId=1";
//   try {
//      return this.http.get<ProductDetailsDescription>(ProductDetailsDescriptionService.GET_ALL_PRODUCTS_CONTROLLER + this.requestParam,httpOptions); 
//   } 
//   catch (error) {
//    console.error('Error in getAllProducts service',error);
//  }
// }


}
